import type { QueryClient } from '@tanstack/react-query';
import { ActivityEndpoints } from 'src/constants/endpoints/activityEndpoints';
import { QueryKeys } from 'src/constants/queryKeys';

export const invalidateActivityStatusSummary = (queryClient: QueryClient, activityId: number) => {
  void queryClient.invalidateQueries({
    queryKey: [QueryKeys.editActivity(activityId), ActivityEndpoints.activityStatusSummary(activityId)]
  });
};
